module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cko9J"))).then(() => parcelRequire('iDabs'));